import React from 'react'
import { useParentPoolAPR } from '../hooks/useParentPoolAPR';

function ChildPoolApr({ rootPoolAddress, childPoolContractAddress, rootPoolEndDate, rootPoolRewardAmount, rootPoolStartDate }) {

    
    // console.log(rootPoolAddress, childPoolContractAddress, rootPoolEndDate, rootPoolRewardAmount, 'props in child apr');

    const { apr,
        childPoolAPR,
        bondSize,
        childBondSize,
        rawTvl,
        childRawTvl } = useParentPoolAPR(rootPoolAddress, rootPoolRewardAmount, rootPoolEndDate, childPoolContractAddress, rootPoolStartDate);
    // console.log(apr,
        // childPoolAPR,
        // bondSize,
        // childBondSize,
        // rawTvl,
        // childRawTvl, 'APR from hook');
  return (
      <>{parseFloat(childPoolAPR)?.toFixed(2)}%</>
  )
}

export default ChildPoolApr